import { toast } from 'react-toastify';
import axios from '../../axios';
import {
   ADD_RECEIVE_LINE_ITEM,
   UPDATE_RECEIVE_LINE_ITEM,
   GET_RECEIVE_LINE_ITEM,
   GET_RECEIVES_LINE_ITEM,
   DELETE_RECEIVE_LINE_ITEM,
} from '../types';

export const getReceivesLineItems = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/receiveLineItem/all', { params });

      if (res.data.code === 1) {
         dispatch({ type: GET_RECEIVES_LINE_ITEM, payload: res.data.data });
      }
   } catch (err) {
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
      // console.error("Failed to get Size. Please try again. :", err);
   }
};

export const addReceiveLineItem = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/receiveLineItem/add', formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_RECEIVE_LINE_ITEM, payload: res.data.data });
         setTimeout(() => {
            toast.success('Receive Line Item added successfully!');
         }, 1000);
      }
      if (res.data.code === 0) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const updateReceiveLineItem = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/receiveLineItem/update`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_RECEIVE_LINE_ITEM, payload: res.data.data });

         setTimeout(() => {
            toast.success('Receive Line Item updated successfully!');
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error("Failed to update Size. Please try again.");
   }
};

export const deleteReceiveLineItem = (id) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/receiveLineItem/delete/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_RECEIVE_LINE_ITEM, payload: { id } });
         setTimeout(() => {
            toast.success('Receive Line Item deleted successfully!');
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error("Failed to delete Size. Please try again.");
   }
};

export const getReceiveLineItem = (id) => async (dispatch) => {
   const res = await axios.get(`/receiveLineItem/${id}`);
   if (res.data.code === 1) {
      dispatch({ type: GET_RECEIVE_LINE_ITEM, payload: res.data.data });
   }
   return res.data.code;
};
